import React, {useEffect, useState} from "react";
import SideBar from "../../../ui/sidebar/sidebar";
import "../styles/userlayout.scss";
import UserHeader from "../../../components/user/header/userheader/userheader";
import useMediaQuery from '@mui/material/useMediaQuery';
import {NavLink} from "react-router-dom";
import AccordionMenu from "../../../ui/accordionmenu/accordionmenu";
import {DashboardManagementIcon} from "../../../modules/icons/dashboardmanagement";
import {CampaignsIcon} from "../../../modules/icons/campaigns";
import {ContentManagementIcon} from "../../../modules/icons/contentmanagement";
import {WebAndAppReceiverIcon} from "../../../modules/icons/webandappreciever";
import {FinancialDepartmentIcon} from "../../../modules/icons/financialdepartment";
import {AccountSettingIcon} from "../../../modules/icons/accountsetting";
import {TijarAssistantIcon} from "../../../modules/icons/tijarassistant";
import {AccountLogoutIcon} from "../../../modules/icons/accountlogout";
import HorizontalDivider from "../../../ui/horizontaldivider/horizontaldivider";

interface IUserLayout {
    children: React.ReactNode
}

const UserLayout = ({children}: IUserLayout) => {
    useEffect(() => {
        document.body.style.backgroundColor = "#E5E5E5"
    }, [])
    const matches = useMediaQuery('(max-width:768px)');
    const [open, setOpen] = useState(!matches);
    const sidebarBody = (
        <div className="d-flex justify-content-end align-items-start flex-column SideBar-Content mt-3">
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/dashboard">
                <DashboardManagementIcon/>
                داشبورد مدیریت
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/campaigns">
                <CampaignsIcon/>
                کمپین ها
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/content-management">
                <ContentManagementIcon/>
                مدیریت محتوا
            </NavLink>
            <AccordionMenu buttonIcon={<WebAndAppReceiverIcon/>} buttonText={"سایت و اپلیکیشن پذیرنده"}
                           panelItems={[
                               {
                                   panelIcon: <></>,
                                   panelText: "گروه های من",
                                   panelLink: "/user/site-and-app-acceptor",
                                   onClick: matches ? () => setOpen(!open) : () => {
                                       return null
                                   }
                               },
                           ]}/>
            <AccordionMenu buttonIcon={<FinancialDepartmentIcon/>} buttonText={"امور مالی"}
                           panelItems={[
                               {
                                   panelIcon: <></>,
                                   panelText: "آیتم تست 1",
                                   panelLink: "/test",
                                   onClick: matches ? () => setOpen(!open) : () => {
                                       return null
                                   }
                               },
                           ]}/>
            <HorizontalDivider/>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/account-setting">
                <AccountSettingIcon/>
                تنظیمات حساب کاربری
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/tijar-assistant">
                <TijarAssistantIcon/>
                دستیار تیجار
            </NavLink>
            <AccordionMenu buttonIcon={<FinancialDepartmentIcon/>} buttonText={"راهنما"}
                           panelItems={[
                               {
                                   panelIcon: <CampaignsIcon/>,
                                   panelText: "آیتم تست",
                                   panelLink: "/user/",
                                   onClick: matches ? () => setOpen(!open) : () => {
                                       return null
                                   }
                               },
                           ]}/>
            <NavLink onClick={matches ?
                () => {
                    setOpen(!open);
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('userType');
                } :
                () => {
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('userType');
                }} className="nav-link" to="/" replace>
                <AccountLogoutIcon/>
                خروج از حساب کاربری
            </NavLink>
        </div>
    )
    return (
        <>
            <SideBar panelChangeTitle={"تغییر به پنل ناشر"} panelChangeTarget={"publisher"} inside={sidebarBody}
                     credit={"1,500,000 تومان"} open={open} close={() => setOpen(!open)}/>
            <div className="User-Content">
                <UserHeader open={open} setOpen={setOpen} job={"تبلیغ کننده"}
                            profile={require("../../../assets/images/avatars/Avatar14.png")}
                            credit={"1,500,000 تومان"} name={"احسان رضایی"} notification={true}/>
                <div className="container px-4">
                    {children}
                </div>
            </div>
        </>
    );
}

export default UserLayout;